import axios from 'axios';
import { API_URL } from '../../global/components/Constants';

export const getCount = async () => {

    try {
      const response = await axios.get(
        `${API_URL}dashboard/dashboard_count`, 
        {withCredentials: true}
      );

      return response.data;
  
    } catch (error) {
      return null;
    }
}